import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15ad1990"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8 col-md-12 blog-main" }

import { reactive } from 'vue';
import Sidebar from '@/blog/components/shared/Sidebar.vue';
import Pagination from '@/blog/components/shared/Pagination.vue';
import CategBreadcrumb from '@/blog/components/category/CategBreadcrumb.vue';
import PostCard from '@/blog/components/shared/PostCard.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const img = reactive({
  cover: require('@/blog/assets/img/blog-cover.png'),
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mainApp: any = document.querySelector('#app');
// console.log(typeof mainApp);

mainApp.style.backgroundImage = 'unset';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CategBreadcrumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(PostCard, {
            cover: _unref(img).cover
          }, null, 8, ["cover"]),
          _createVNode(Pagination)
        ]),
        _createVNode(Sidebar, { class: "" })
      ])
    ])
  ], 64))
}
}

})